import React, { useState } from "react";
import { HStack, Input, Button } from "@chakra-ui/react";

const TalentPoolEditor = ({ onCreate, isLoading }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleCreate = async () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    await onCreate?.({ name: trimmed, description });
    setName("");
    setDescription("");
  };

  return (
    <HStack>
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Pool name"
      />
      <Input
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Description"
      />
      <Button colorScheme="blue" onClick={handleCreate} isLoading={isLoading}>
        Create
      </Button>
    </HStack>
  );
};

export default TalentPoolEditor;
